import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import ModalHeader from 'components/Modal/ModalHeader';
import { reduxForm, FieldArray, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { onCancelSalesTypeModal } from 'actions/library/item';
import SalesTypeFieldArray from './SalesTypeFieldArray';
import styles from './SalesTypeModal.css';

class SalesTypeModal extends React.Component {
  render() {
    const { showSalesTypeModal, handleSubmit, salesType } = this.props;

    return (
      <Modal
        show={showSalesTypeModal}
        onHide={this._onCancel}
        dialogClassName={`modal-dialog ${styles.dialog}`}
      >
        <ModalHeader title={'Manage Sales Type'} />
        <form onSubmit={handleSubmit}>
          <Modal.Body bsClass={`modal-body ${styles.body}`}>
            <FieldArray name="sales_type" component={SalesTypeFieldArray} />
          </Modal.Body>
          <Modal.Footer>
            <span className="pull-left">
              <button
                className="btn btn-default"
                type="button"
                onClick={this._onCancel}
              >
                Cancel
              </button>
            </span>
            <span className="pull-right">
              <button
                disabled={
                  salesType &&
                  salesType.sales_type.filter(st => st.selected).length === 0
                }
                className="btn btn-primary"
                type="submit"
              >
                Confirm
              </button>
            </span>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  _onCancel = () => {
    const { dispatch, previousItemForm } = this.props;
    dispatch(onCancelSalesTypeModal(previousItemForm));
  };
}

function mapStateToProps(state) {
  const { showSalesTypeModal, previousItemForm } = state.library.item;
  return {
    showSalesTypeModal,
    previousItemForm,
    salesType: getFormValues('modal_sales_type')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

SalesTypeModal.propTypes = {
  onSubmit: PropTypes.func,
  dispatch: PropTypes.func,
};

const mapForm = {
  form: 'modal_sales_type',
  touchOnBlur: false,
  touchOnChange: true,
};

export default reduxForm(mapForm)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SalesTypeModal)
);
